import React, { useState, useEffect } from "react";
import useGetRequest from "../../hooks/useGetRequest";
import { IReportSettings } from "../../types/reportSettings.type";
import {
  Button,
  Spin,
  Alert,
  Form,
  Checkbox,
  Modal,
  message,
  Card,
} from "antd";
import { api } from "../../api/api";

export default function ReportSettings() {
  const { data, loading, error } = useGetRequest("/settings/report");
  const [reportSettings, setReportSettings] = useState<IReportSettings | null>(
    null
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (data?.reportSettings) {
      setReportSettings(data.reportSettings);
    }
  }, [data]);

  const updateReportSettings = async (values: IReportSettings) => {
    setIsLoading(true);
    try {
      await api.post("/settings/report", values);
      setReportSettings(values);
      message.success("Настройки успешно обновлены!");
      setIsModalVisible(false);
    } catch (error) {
      message.error("Ошибка при обновлении настроек.");
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (loading) {
    return <Spin tip="Загрузка..." />;
  }

  if (error) {
    return <Alert message="Ошибка при загрузке данных" type="error" showIcon />;
  }

  return (
    <div>
      <h2>Настройки отчета</h2>

      {reportSettings && (
        <Card title="Текущие настройки" style={{ marginBottom: 16 }}>
          <p>
            <strong>Дата:</strong>{" "}
            {reportSettings.date ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Менеджер склада:</strong>{" "}
            {reportSettings.warehouseMgr ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Количество:</strong>{" "}
            {reportSettings.quantity ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Отход:</strong>{" "}
            {reportSettings.wasteProduce ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Подпись:</strong>{" "}
            {reportSettings.sign ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Остаток до:</strong>{" "}
            {reportSettings.residueBefore ? "Показывать" : "Не показывать"}
          </p>
          <p>
            <strong>Остаток после:</strong>{" "}
            {reportSettings.residueAfter ? "Показывать" : "Не показывать"}
          </p>
        </Card>
      )}

      <Button type="primary" onClick={showModal}>
        Изменить настройки
      </Button>

      <Modal
        title={reportSettings ? "Обновить настройки" : "Добавить настройки"}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        <Form
          initialValues={reportSettings || {}}
          onFinish={updateReportSettings}
          layout="vertical"
        >
          <Form.Item name="date" label="Дата" valuePropName="checked">
            <Checkbox>Показывать дату</Checkbox>
          </Form.Item>

          <Form.Item
            name="warehouseMgr"
            label="Менеджер склада"
            valuePropName="checked"
          >
            <Checkbox>Показывать менеджера склада</Checkbox>
          </Form.Item>

          <Form.Item name="quantity" label="Количество" valuePropName="checked">
            <Checkbox>Показывать количество</Checkbox>
          </Form.Item>

          <Form.Item name="wasteProduce" label="Отход" valuePropName="checked">
            <Checkbox>Показывать отход</Checkbox>
          </Form.Item>

          <Form.Item name="sign" label="Подпись" valuePropName="checked">
            <Checkbox>Показывать подпись</Checkbox>
          </Form.Item>

          <Form.Item
            name="residueBefore"
            label="Остаток до"
            valuePropName="checked"
          >
            <Checkbox>Показывать остаток до</Checkbox>
          </Form.Item>

          <Form.Item
            name="residueAfter"
            label="Остаток после"
            valuePropName="checked"
          >
            <Checkbox>Показывать остаток после</Checkbox>
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            loading={isLoading}
            style={{ marginTop: 16 }}
          >
            {reportSettings ? "Обновить настройки" : "Добавить настройки"}
          </Button>
        </Form>
      </Modal>
    </div>
  );
}
